import { Link } from "react-router-dom";
import { getPopularArticles } from "@/mocks/articles";

const discussions = getPopularArticles(3);

export default function FanDiscussion() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs tracking-[0.2em] text-accent-500 mb-2 font-medium">
              粉丝社区
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
              热门热议
            </h2>
          </div>
          <Link
            to="/category/discussion"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            加入讨论 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-2/3">
            <div className="flex flex-col gap-4">
              {discussions.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group flex gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-100/80 transition-all duration-300"
                >
                  <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                        #{index + 1} 热门
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 mt-1">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="hidden sm:flex flex-col items-center justify-center gap-1 text-foreground-500 flex-shrink-0">
                    <span className="text-lg font-semibold text-primary-500">
                      {article.likes.toLocaleString()}
                    </span>
                    <span className="text-xs">赞</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="bg-background-100 rounded-xl p-6 sticky top-24">
              <h3 className="text-base font-semibold text-foreground-950 mb-4">
                关于粉丝社区
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                这里是苍井樱粉丝的聚集地。在这里，你可以与其他粉丝一起讨论苍井樱的最新动态、分享收藏的图片和视频、交流观后感和心得体会。
              </p>
              <div className="flex flex-wrap gap-2 mb-5">
                {["作品讨论", "图片分享", "新闻速递", "应援活动", "二手交易", "线下聚会"].map(
                  (tag) => (
                    <span
                      key={tag}
                      className="text-xs px-3 py-1.5 bg-background-50 text-foreground-700 rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  )
                )}
              </div>
              <Link
                to="/category/discussion"
                className="block w-full text-center py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                进入粉丝社区
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}